import React, { useState } from "react";
import { HashLink } from "react-router-hash-link";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header
      className="
    sticky top-0 z-50 shadow-md
    bg-[url('/images/header.jpg')]
    bg-no-repeat bg-center
    bg-cover
    min-h-[90px] md:min-h-0
  "
    >

      {/* Top Row */}
      <div className="max-w-7xl mx-auto px-3 md:px-4 py-3 md:py-4 flex items-center justify-between">
        {/* Logo & Title */}
        <div className="flex items-center gap-2">
          <img
            src="/images/studypartnerlogo.png"
            alt="Study Partners Logo"
            className="h-9 w-9 md:h-30 md:w-30"
          />

        </div>

        {/* Mobile Hamburger Icon */}
        <div className="md:hidden">
          <button onClick={() => setMenuOpen(!menuOpen)}>
            {menuOpen ? (
              <X size={26} color="#3498db" />
            ) : (
              <Menu size={26} color="#3498db" />
            )}
          </button>
        </div>
      </div>

      <div className="bg-[#3498db] text-white hidden md:block">
        <nav className="max-w-7xl mx-auto px-4 py-3 flex-wrap justify-center gap-6 text-lg font-semibold flex">
          <HashLink smooth to="/#hero" className="hover:underline">Home</HashLink>
          <HashLink smooth to="/#about" className="hover:underline">About</HashLink>
          <HashLink smooth to="/#faq" className="hover:underline">FAQs</HashLink>
          <HashLink smooth to="/#help" className="hover:underline">Help</HashLink>
          <HashLink smooth to="/#contact" className="hover:underline">Contact Us</HashLink>
        </nav>
      </div>

      {/* Mobile Dropdown Menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#3498db] px-4 pb-4 text-white">
          <nav className="flex flex-col gap-4 font-medium text-base">
            <HashLink smooth to="/#hero" onClick={() => setMenuOpen(false)}>Home</HashLink>
            <HashLink smooth to="/#about" onClick={() => setMenuOpen(false)}>About</HashLink>
            <HashLink smooth to="/#faq" onClick={() => setMenuOpen(false)}>FAQs</HashLink>
            <HashLink smooth to="/#help" onClick={() => setMenuOpen(false)}>Help</HashLink>
            <HashLink smooth to="/#contact" onClick={() => setMenuOpen(false)}>Contact Us</HashLink>

          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
